import React from "react";
import BudgetInfo from "../Components/BudgetInfo/BudgetInfo.js";
export default function BudgetGuide(props){
    return (<>
    <div>
        <BudgetInfo/>
    </div>
    </>);
}